// Generated by Melange

import * as Caml_option from "melange.js/caml_option.js";
import * as Curry from "melange.js/curry.js";
import * as Lui_extension from "lui/lui_extension.js";
import * as Lui_protocol from "lui/lui_protocol.js";
import * as Lui_ui from "lui/lui_ui.js";
import * as Signal from "ocaml-signal/signal.js";
import * as Stdlib from "melange/stdlib.js";
import * as Stdlib__Option from "melange/option.js";
import * as Stdlib__String from "melange/string.js";

const identifier = "mapre-dockerfile-input";

const invalid = "Dockerfile must be UTF-8 text of at most 64 KiB.";

function create(_node, $$document, emit) {
  const el = $$document.createElement("input");
  el.setAttribute("type", "file");
  el.setAttribute("aria-label", "Upload Dockerfile");
  el.className = "dockerfile-upload";
  const state = {
    generation: 0,
    live: true,
    enabled: true,
    change: (function (param) {
      
    })
  };
  const change = function (param) {
    const selected = Stdlib__Option.bind(Caml_option.nullable_to_opt(el.files), (function (files) {
      return Caml_option.nullable_to_opt(files.item(0));
    }));
    el.value = "";
    if (state.live && state.enabled) {
      return Stdlib__Option.iter((function (param) {
        state.generation = state.generation + 1 | 0;
        const generation = state.generation;
        const active = function (param) {
          if (state.live && state.enabled) {
            return generation === state.generation;
          } else {
            return false;
          }
        };
        const fail = function (param) {
          if (active()) {
            return Curry._2(emit, "failed", Curry._2(Lui_protocol.String_map.singleton, "message", {
              TAG: /* StringValue */ 0,
              _0: invalid
            }));
          }
          
        };
        if (param.size > 65536) {
          return fail();
        } else {
          param.arrayBuffer().then(function (bytes) {
            if (active()) {
              const content = new TextDecoder("utf-8", {
                  fatal: true
                }).decode(bytes);
              if (Stdlib__String.contains(content, /* '\000' */0)) {
                fail();
              } else {
                Curry._2(emit, "uploaded", Curry._3(Lui_protocol.String_map.add, "content", {
                  TAG: /* StringValue */ 0,
                  _0: content
                }, Curry._3(Lui_protocol.String_map.add, "name", {
                  TAG: /* StringValue */ 0,
                  _0: param.name
                }, Lui_protocol.String_map.empty)));
              }
            }
            return Promise.resolve();
          }).catch(function (param) {
            fail();
            return Promise.resolve();
          });
          return;
        }
      }), selected);
    }
    
  };
  state.change = change;
  el.__mapreFileState = state;
  el.addEventListener("change", change);
  return el;
}

function set_property(el, key, property) {
  if (key !== "disabled") {
    return Stdlib.invalid_arg("invalid_dockerfile_input_property");
  }
  if (property.TAG !== /* BoolValue */ 1) {
    return Stdlib.invalid_arg("invalid_dockerfile_input_property");
  }
  const is_disabled = property._0;
  const state = el.__mapreFileState;
  state.enabled = !is_disabled;
  if (is_disabled) {
    state.generation = state.generation + 1 | 0;
  }
  el.disabled = is_disabled;
}

function cleanup(el) {
  const state = el.__mapreFileState;
  state.live = false;
  state.generation = state.generation + 1 | 0;
  el.removeEventListener("change", state.change);
}

function component(param) {
  return Lui_extension.component(identifier, {
    hd: {
      profile_os: /* WebOS */ 1,
      profile_host: /* WebHost */ 1
    },
    tl: /* [] */ 0
  }, false, /* [] */ 0, {
    hd: Lui_extension.property("disabled", /* BoolScalar */ 1, false, {
      TAG: /* BoolValue */ 1,
      _0: false
    }),
    tl: /* [] */ 0
  }, {
    hd: Lui_extension.$$event("uploaded", {
      hd: Lui_extension.event_field("name", /* StringScalar */ 0, true),
      tl: {
        hd: Lui_extension.event_field("content", /* StringScalar */ 0, true),
        tl: /* [] */ 0
      }
    }),
    tl: {
      hd: Lui_extension.$$event("failed", {
        hd: Lui_extension.event_field("message", /* StringScalar */ 0, true),
        tl: /* [] */ 0
      }),
      tl: /* [] */ 0
    }
  });
}

function adapter_web_extension_remove_property(el, param) {
  set_property(el, "disabled", {
    TAG: /* BoolValue */ 1,
    _0: false
  });
}

const adapter = {
  web_extension_create: create,
  web_extension_set_property: set_property,
  web_extension_remove_property: adapter_web_extension_remove_property,
  web_extension_cleanup: cleanup
};

function handle(on_upload, on_error, param) {
  if (param.TAG !== /* ExtensionEvent */ 22) {
    return;
  }
  const id = param._1;
  switch (param._2) {
    case "failed" :
      if (id === identifier) {
        return Curry._1(on_error, invalid);
      } else {
        return;
      }
    case "uploaded" :
      if (id !== identifier) {
        return;
      }
      const fields = param._3;
      const match = Curry._2(Lui_protocol.String_map.find_opt, "name", fields);
      const match$1 = Curry._2(Lui_protocol.String_map.find_opt, "content", fields);
      if (match !== undefined && match.TAG === /* StringValue */ 0 && match$1 !== undefined && match$1.TAG === /* StringValue */ 0) {
        return Curry._2(on_upload, match._0, match$1._0);
      } else {
        return Curry._1(on_error, invalid);
      }
    default:
      return;
  }
}

function view(disabled, on_upload, on_error, context, parent) {
  const node = Lui_ui.extension(context, identifier);
  Lui_ui.extension_property_signal(context, node, "disabled", Signal.map((function (value) {
    return {
      TAG: /* BoolValue */ 1,
      _0: value
    };
  }), disabled));
  Lui_ui.on_event(context, node, (function (param) {
    return handle(on_upload, on_error, param);
  }));
  Stdlib__Option.iter((function (parent) {
    Lui_ui.append(context, parent, node);
  }), parent);
  return node;
}

export {
  identifier,
  component,
  adapter,
  handle,
  view,
}
/* Lui_extension Not a pure module */
